import { saveAs } from "file-saver";
import JSZip from "jszip";
import './App.css';
import React from 'react';
import { gapi } from 'gapi-script';
import { browserName } from 'react-device-detect';


import Masonry from "react-masonry-css";


import global from './Global';
const _app = new global();
const driveId = '0AOfgygLv6_dZUk9PVA';
const folderId = '1q3Whgx_PFfzP_-pPUA23_qyRWY8e400r';
const fileSize = (b) => {
  var u = 0, s=1024;
  while (b >= s || -b >= s) {
      b /= s;
      u++;
  }
  return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
}

const breakpointColumnsObj = {
  default: 5,
  1400: 4,
  800: 3,
  600: 2,
  500: 1,
};

const allowedBroswers = ['Edge','Chrome','Safari','Mobile Safari','Opera'];

class App extends React.Component{

  constructor(props){
    super(props);
    
    this.state = {
      loaded: false,
      filesLoaded: false,
      driveId: '0AOfgygLv6_dZUk9PVA',
      folderId: null,
      uprogress: [],
      notifications: [],
      breadcrumb: [],
      contextMenu: [],
      files: null,
      isError: null,
      
    }
    this.uprogress = [];
    this.notifications = [];
    this.breadcrumb = [];
    this.imageList = [];
  }
 async componentDidMount(){
    
  _app.gapi.script.onload = this.handleClientLoad;
    document.body.appendChild(_app.gapi.script);
    document.body.appendChild(_app.gapi.accountscript);
    //const me = this;
    setTimeout(async()=>{
      await this.listFiles(`0AOfgygLv6_dZUk9PVA`, `('1q3Whgx_PFfzP_-pPUA23_qyRWY8e400r' in parents)`);
    }, 2000);
  }

  extractIdFromUrl(url) {
    // Use a regular expression to extract the ID from the URL
    const match = url.match(/\/gallery\/([^\/]+)(\/|$)/);
  return match ? match[1] : null;
  }


  hideMenu = (e) => { 
      
      if( document.getElementById("contextMenu") !== null){

        document.getElementById("contextMenu").style.display = "none";
        // for(const flink of e.target.querySelectorAll('.fileLink')){
      }
     //   flink.parentNode.classList.remove('focused');
    //  }
      
  } 

  rightClick = (e) => { 
      e.preventDefault(); 
      let json;
      let type;
      
      try{
        json = e.target.getAttribute('data-json');
        json = JSON.parse(json);
        type = json.mimeType;
        this.setState({
          cdata: json
        });
      }catch(ex){
      }
      
      this.contextItems = [];
      //e.target.parentNode.parentNode.parentNode.classList.add('focused');
      if (document.getElementById("contextMenu").style.display === "block"){ 
          this.hideMenu(e); 
      }else{ 
          if(type === 'application/vnd.google-apps.folder'){
            this.contextItems.push(
              <li className="share d-none"><a href="#"><i className="fa fa-share" aria-hidden="true"></i> Share</a></li> 
            );

            this.contextItems.push(
              <li className="share d-none"><a href="#"><i className="fa-light fa-folder-open"></i> Open Folder</a></li> 
            );
            
            
            
            
          }else{
            this.contextItems.push(
              <li className="share d-none"><a href="#"><i className="fa fa-share" aria-hidden="true"></i> Share</a></li> 
            );
            
            this.contextItems.push(
              <li className="share d-none"><a href="#"><i className="fa-solid fa-eye"></i> Open File</a></li> 
            );

            
          }
          if(json !== null && json.webContentLink !== undefined){
            this.contextItems.push(
              <li className="download"><a href={json.webContentLink}><i className="fa fa-download" aria-hidden="true"></i> Download</a></li> 
            );
          }
         
          
          
          this.setState({
            contextMenu: this.contextItems
          })
          var menu = document.getElementById("contextMenu")      
          menu.style.display = 'block'; 
          menu.style.left = e.pageX + "px"; 
          menu.style.top = e.pageY + "px"; 
      } 
  }

  handleClientLoad = async ()=>{
    gapi.load('client:auth2', this.initClient);
    
  }

  handleLogin = async(e = false) => {
    try{

      gapi.auth2.getAuthInstance().signIn();
    }catch(ex){
      console.log(ex);
    }
  }



  handleSignoutClick =  (e) => {
    const token = window.gapi.client.getToken();
    if (token !== null) {
      let cnf = window.confirm('Are you sure to sign out?');
      if(cnf){
        window.google.accounts.oauth2.revoke(token.access_token);
        window.gapi.client.setToken('');
       // gapi.auth2.getAuthInstance().signOut();
        
        this.setState({
          responseToken: '',
          gapiInited: false,
          gisInited: false
        });
        setTimeout(()=>{
          gapi.auth2.getAuthInstance().signOut();
          window.location.reload();
        }, 1000)
        return false;
      }
      
    }
    
  }

  Authorize = async() => {
    let gu = window.gapi.auth2.getAuthInstance();
    return window.gapi.auth2.getAuthInstance()
        .signIn({scope: _app.gapi.scopes})
        .then(function() { console.log("Sign-in successful"); },
              function(err) { console.error("Error signing in", err); });
    
  }

  updateSigninStatus = (isSignedIn) => {
    if (isSignedIn) {
      // Set the signed in user
      let user = gapi.auth2.getAuthInstance().currentUser;
      //console.log(gapi.auth2.getAuthInstance().currentUser);
      this.setState({
        user: user,
        gapiInited: true
      })
      
      
      // list files if user is authenticated
      //listFiles();
    } 
  };

  initClient = async () => {
    try{
      this.setState({
        gisInited: true
      });
      
      gapi.client.init({
        apiKey: _app.gapi.apiKey,
        discoveryDocs: [_app.gapi.discoveryUrl],
        client_id: _app.gapi.clientId,
        scope: _app.gapi.scopes,
      }).then(()=>{
        gapi.auth2.getAuthInstance().isSignedIn.listen(this.updateSigninStatus);
        console.log(gapi.auth2.getAuthInstance().isSignedIn.get());
        if(gapi.auth2.getAuthInstance().isSignedIn.get()){
          this.updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
        }
       
      }).catch((err)=>{
        this.setState({
          isError: err,
          loaded: true,
          filesLoaded: true
        });
        console.log(err);
      })
      
      
         /// this.state.googleAuth.isSignedIn.listen(this.updateSigninStatus);  

           //   console.log(this.state.googleAuth);
       //  document.getElementById('signout-btn').addEventListener('click', this.signOutFunction);

      
    }catch(e){
      console.log(e);
    }
  }

  

  listFiles = async (drive = false, searchTerm = `('${this.state.driveId}' in parents)`, result = false) => {
    if(!result){
      this.setState({
        filesLoaded: false,
        files: null
      });
    }
    
    
    searchTerm = drive ? searchTerm.replace("'root'", `'${drive}'`) : searchTerm;
    
    let params;
    if(drive === 'root'){
      params = {
          "orderBy": "folder, createdTime desc, name",
          pageSize: 500,
          fields: 'nextPageToken, files(id, name, mimeType, modifiedTime, size, version, webContentLink, webViewLink, iconLink, thumbnailLink, createdTime, sharingUser)',
          q: searchTerm,
        }
    }else if(drive === 'shared'){
      searchTerm = 'sharedWithMe=true and trashed=false';
      params = {
          "orderBy": "folder,createdTime desc,name",
          pageSize: 500,
          fields: 'nextPageToken, files(id, name, mimeType, modifiedTime, size, version, webContentLink, webViewLink, iconLink, thumbnailLink, createdTime, sharingUser)',
          q: searchTerm,
        }
    }else if(drive === 'trash'){
      searchTerm = 'trashed=true';
      params = {
          "orderBy": "folder,createdTime desc,name",
          pageSize: 500,
          fields: 'nextPageToken, files(id, name, description, mimeType, modifiedTime, size, version, webContentLink, webViewLink, iconLink, thumbnailLink, createdTime, sharingUser)',
          q: searchTerm,
        }
    }else{
      params = {
        "corpora": "drive",
        "includeTeamDriveItems": true,
        "orderBy": "folder,createdTime desc,name",
        "supportsAllDrives": true,
        "supportsTeamDrives": true,
        pageSize: 500,
        driveId: drive,
        teamDriveId: drive,
        fields: 'nextPageToken, files(id, name, description, mimeType, modifiedTime, size, version, webContentLink, webViewLink, iconLink, thumbnailLink, createdTime, sharingUser)',
        q: searchTerm + ' and trashed=false',
      }
    }
    if(gapi.client !== undefined && gapi.client.drive !== undefined){
      let resp = await gapi.client.drive.files.list(params);
      if(!result){
        
      this.setState({
        filesLoaded: true,
      });
      if(resp.result !== undefined && resp.result.files !== undefined){
        this.setState({
          files: resp.result.files
        }, ()=>{
          //console.log(this.state.files)
        })
      }
      }else{
        return resp.result.files;
      }
    }
    
  };

  

  changeLocation = async (e, attr = {}) => {
    
    let parms;
    if(typeof(e) === 'object' && e.target !== undefined){
      e.preventDefault();
      parms = `('${e.target.getAttribute('data-id')}' in parents)`;
      
      await this.listFiles(this.state.driveId, parms, e.target.getAttribute('data-name'));
      this.breadcrumb.push({name: e.target.getAttribute('data-name'), id: e.target.getAttribute('data-id'), type: 'folder', _key: this.breadcrumb.length});
      
      this.setState({
        folderId: e.target.getAttribute('data-id'),
        breadcrumb: this.breadcrumb
      })
    }else{
      await this.listFiles(this.state.driveId, `'${e}' in parents`);
      
      this.breadcrumb.push({name: attr.name, id: e, type: attr.type !== undefined ? attr.type : attr.mimeType === 'application/vnd.google-apps.folder' ? 'folder' : attr.mimeType, _key: this.breadcrumb.length});

      //this.breadcrumb = this.breadcrumb.filter((x, i) => i + (parseInt(attr.idx) + 1) < this.breadcrumb.length);
      
      
      this.setState({
        folderId: e,
        breadcrumb: this.breadcrumb
      })
    }
    
  }


  driveRefresh = async () => {
    
    await this.listFiles(this.state.driveId, `('${this.state.folderId}' in parents)`);
    
  }

  moveto = async (e) => {
    let data = e.target.getAttribute('data');
    document.querySelector('.breadcrumb-item').classList.remove('active');
    e.target.parentNode.classList.add('active');
    data = JSON.parse(data);
    
    data['idx'] =  e.target.getAttribute('id');
    if(data.type === 'drive'){
      await this.changedrive(data.id, data);
    }else{
      await this.changeLocation(data.id, data);
    }
    //await this.listFiles(this.state.driveId, `('${this.state.folderId}' in parents)`);
  }

  closeNotification = (e) => {
    e.target.parentNode.remove();
  }

  toggleNav = () => {
    this.setState({
      showMenu: this.state.showMenu ? false : true
    })
  }

  readImage = async (url, isblob = false) => {
    //url = type.toUpperCase() === 'S3' ? `${url}` : `https://api.dreamzlive.com/get-google-drive-file-link/?id=${url}`;
   
    let res = !isblob ? await fetch(url) : url;
    
    if(res.ok){
      return await res.blob();
    }
    return res;
  }

  readGoogleImage = async (id) => {
    let img;
    if(gapi.client !== undefined && gapi.client.drive !== undefined){
      let resp = await gapi.client.drive.files.get({
        fileId: id,
        alt: "media"
      });
      if(resp.status === 200){
        const imageData = resp.body;
        const byteArray = new Uint8Array(imageData.length);
        for (let i = 0; i < imageData.length; i++) {
            byteArray[i] = imageData.charCodeAt(i) & 0xff;
        }
        return new Blob([byteArray], { type: resp.headers["Content-Type"] });
      }
    }
  }

  getDriveImageLink = async (id) => {
    let res = await fetch(`https://api.dreamzlive.com/get-google-drive-file-link/?id=${id}`);
  
    if(res.ok){
      return await res.json();
    }
  }

  


  getSDPhotos = async (id, name = '') => {
    id = this.extractIdFromUrl(id);
    console.log(id);
    if(id !== null){
      let qry = `col=gallerycontents&qry={"$and":[{"galleryId":"${id}"},{"isDeleted":false}]}&limit=100&order={"isFeatureActive":-1}`;
    //  console.log(id);
      let resp = await fetch(`https://sssmediacentre.org/api/public/find/?${(qry)}`);
      if(resp.ok){
        resp = await resp.json();
        if(resp.data !== undefined){
          this.imageList = resp.data.map(x => `https://s3.ap-south-1.amazonaws.com/content.sssmediacentre.org/${x.imagePath}`);
          this.setState({
            notifications: [...this.state.notifications, {
              id: id,
              type: 'success',
              class: 'list-group-item list-group-item-warning',
              msg: <><strong>[{name}]</strong><hr /><img src="/loading.gif" style={{maxWidth:"18px"}} alt="" /> {this.imageList.length} files are being zipped</>
            }]
          });
          await this.downloadImages(this.imageList, id, name );
        }
      }
      
    }
   
  }

  getHDPhotos = async  (drive, search, name = '') => {
    this.setState({
      notifications: [...this.state.notifications, {
        id: search,
        type: 'success',
        class: 'list-group-item list-group-item-warning',
        msg: <><strong>[{name}]</strong><hr /><img src="/loading.gif" style={{maxWidth:"18px"}} alt="" /> Getting file list</>
      }]
    });
    let notifications;
    
    let list = await this.listFiles(drive, `('${search}' in parents)`, true);
    let imageList = list.map(x => x.id);
   
    for(let i = 0; i < imageList.length; i++){
      notifications = this.state.notifications.map((item)=>{
        if(item.id === search){
          item.class = 'list-group-item list-group-item-warning';
          item.msg = <><strong>[{name}]</strong><hr /><img src="/loading.gif" style={{maxWidth:"18px"}} alt="" /> Collecting file data {(i + 1)} of {imageList.length}</>
          
        }
        return item
    });
    this.setState({
      notifications: notifications
    });
   // imageList[i] = await this.getDriveImageLink(imageList[i]);
   

     // if(imageList[i].endpoint !== undefined){
     //   imageList[i] = imageList[i].endpoint;
     // }else{ https://www.googleapis.com/drive/v3/files/id/?alt=media&supportsAllDrives=true&key=AIzaSyB6ObEpNufbTPL7_RJe1tnwTICzioVCX8g
        imageList[i] = await this.readGoogleImage(`${imageList[i]}`);
     // }
    }
    await this.downloadImages(imageList, search, name, true);
  }

  ToValidFileName(name) {
    return name
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, '') // Remove non-alphanumeric characters and hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
      .trim(); // Remove leading/trailing spaces and hyphens
  }

  downloadImages = async(urls = [], id, filename = 'sssmediacentre-gallery', isblob = false) => {
    filename = filename === '' ? 'sssmediacentre-gallery' : filename;
    var zip = new JSZip();
    var count = 0;
    
    let files = {
      total: urls.length,
      processing: 0,
      processed: count,
    };
    var nameFromURL = [];

    var the_arr = "";
    /*for (var i = 0; i < urls.length; i++) {
      the_arr = urls[i].split("/");
      nameFromURL[i] = the_arr.pop();
    }*/

    let notifications;
    for (var i = 0; i < urls.length; i++) {
      files['processing'] = (i + 1);
      
      let file = await this.readImage(urls[i], isblob);
      
      zip.file(`${filename}-${i}.jpg`, file);
      files['processed'] = (i + 1);
      notifications = this.state.notifications.map((item)=>{
        if(item.id === id){
          item = {
            id: id,
            type: 'success',
            class: 'list-group-item list-group-item-warning',
            msg: <><strong>[{filename}]</strong><hr /><img src="/loading.gif" style={{maxWidth:"18px"}} alt="" /> {files.processed} of {files.total} files added to download</>
          }
        }
        return item;
      })
      this.setState({
        notifications: notifications
      }); 
    }
    notifications = this.state.notifications.map((item)=>{
      if(item.id === id){
        item = {
          id: id,
        type: 'success',
        class: 'list-group-item list-group-item-success',
        close: true,
        msg: <><strong>[{filename}]</strong><hr /><i className="fa-solid fa-circle-check"></i> Ready To Download</>
        }
      }
      return item;
    })
    this.setState({
      notifications: notifications,
    }); 
    var zipFile = await zip.generateAsync({ type: "blob" });
    saveAs(zipFile, this.ToValidFileName(filename));
    notifications = this.state.notifications.map((item)=>{
      if(item.id === id){
        item = {
          id: id,
        type: 'success',
        class: 'list-group-item list-group-item-success',
        close: true,
        msg: <><strong>[{filename}]</strong><hr /><i className="fa-solid fa-circle-check"></i> Downloaded</>
        }
      }
      return item;
    })
    this.setState({
      notifications: notifications,
    }); 
   
    
  }

  isEmpty = (variable) => {
    switch(typeof variable){
      case 'object':
        if((Array.isArray(variable))){
          return  variable.length < 1;
        }else if(variable === null){
          return true;
        }else{
          return Object.keys(variable).length < 1;
        }
      break;
      case 'number':
        return variable === '' || isNaN(variable);
      case 'bigint':
        return variable === '' || isNaN(variable);
      case 'undefined':
        return true;
      
      case 'string':
        return variable.length < 1;
      default:
      return variable === null;
      break;
    }
    
  }

  render(){
    const state = this.state;
    const props = this.props;
    return (
      <div className="App" onClick={this.hideMenu}>
        
        <header className="App-header mt-3">
          <div className='row'>
            <div className='col-md-12 col-12'>
                <div className='text-center'>
                  <span className='badge bg-primary text-white text-center' style={{whiteSpace:"pre-line"}}><h1 className='display-5 m-0 text-white'>Download Photos of Mandir Programs</h1></span>
                </div>
                  
            </div>
            <div className='col-md-2 col-2 align-self-center'>
              {
                state.gapiInited && state.gisInited ? 
                <div className='text-end d-none'>
                  
                  <button title="Sign Out" onClick={this.handleSignoutClick} className='btn btn-sm btn-danger'>
                    <i className="fa-solid fa-right-from-bracket"></i>
                  </button>
                </div>:
                <div className='text-end d-none'>
                <button title="Sign In" onClick={this.handleLogin} className='btn btn-sm btn-primary'>
                <i className="fa-solid fa-right-to-bracket"></i> Sign In
                </button>
              </div>
              }
              
            </div>
          </div>
        </header>
        <main>
              <div className='wrapper'>
                {
                  !allowedBroswers.includes(browserName) && 
                   <div className='alert alert-danger'>
                    <i className="fa-solid fa-triangle-exclamation"></i> This browser `{browserName}` may be not compatible. Please use any of {allowedBroswers.join(', ')} for the best experience.
                  </div>
                  
                }
                {
                  this.state.isError !== null &&
                  <div className='alert alert-danger'>

                    {
                      !this.isEmpty(this.state.isError.details) &&
                      <div>{this.state.isError.details === 'Cookies are not enabled in current environment.' ? `This app uses cookies. ${this.state.isError.details}` : `${this.state.isError.details}`}</div>
                    }
                    
                  </div>
                }
                <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li  className="breadcrumb-item">
                        <button onClick={()=>{
                          this.breadcrumb = [];
                          this.setState({
                            breadcrumb: this.breadcrumb
                          },()=>{
                            this.listFiles(driveId, `('${folderId}' in parents)`);
                          });
                         
                        }} className='btn btn-sm btn-secondary'>
                          <i className="fa-solid fa-folder-tree"></i> Main Folder {this.state.folderId === folderId && <i className="fa-solid fa-rotate"></i>}
                        </button>
                        </li>
                      {
                        this.state.breadcrumb.length > 0 ? 
                        this.state.breadcrumb.map((x,i)=>{
                          return (<li className="breadcrumb-item" data-id={x.id} key={x.id} data-key={x._key} style={{flex:"1"}}><button className={x.id === this.state.folderId ? "btn btn-sm btn-light" : "btn btn-sm btn-secondary"} style={{
                            whiteSpace: "pre-line",
                            lineBreak: "anywhere",
                            wordBreak: "break-word"
                          }} onClick={async (e)=>{
                            
                            this.breadcrumb = this.state.breadcrumb;
                            let i = e.target.getAttribute('data-key');
                            do{
                              i++;
                              if(this.breadcrumb[i] !== undefined){
                                delete(this.breadcrumb[i]);
                              }
                            }while(i < this.breadcrumb.length);
                            this.setState({
                              breadcrumb: this.breadcrumb
                            }, async () => {
                              await this.listFiles(`0AOfgygLv6_dZUk9PVA`, `('${x.id}' in parents)`);
                            
                            })
                            
                          }} id={i}>{x.name} {this.state.folderId === x.id && <i className="fa-solid fa-rotate"></i>}</button></li>);
                        }) : <></>
                      }
                      </ol>
                  </nav>
                {
                  this.state.user === null ?
                  
                  <div className='row'>
                  <div className='col-md-12 text-center align-self-center' style={{maxWidth: '50vh', background:'#fff', borderRadius:'15px', padding:'30px', margin:'10% auto', fontSize:'18px'}}>
                  <img src="https://raw.githubusercontent.com/hlynurstef/bs-google-signin/HEAD/assets/google-signin-button.png" alt='login with Google' style={{maxWidth:'100%', cursor:'pointer'}} onClick={this.handleLogin} />
                     
                      
                  </div>
                  </div> :
                  <>
                    <div id="result">
                          <ul className="list-group">
                            {this.state.uprogress.map((x,i)=>{
                              return (<li key={x.name} className={ x.percent === '100%' ? "list-group-item mb-1 list-group-item-success" : "list-group-item mb-1 list-group-item-warning" }>
                                {x.name} {x.percent === '100%' ? <i className="fa-solid fa-square-check"></i> : x.percent}
                                <button className='close'  title="Close Notification"  onClick={(e)=>{
                                    delete(this.uprogress[i]);
                                    
                                    this.setState({
                                      uprogress: this.uprogress
                                    })
                                  }}><i className="fa-solid fa-circle-xmark"></i></button></li>)
                            })}
                          </ul>
                          <ul className="notification list-group">
                            {
                              this.state.notifications.map((x, i)=>{
                                return (
                                  <li className={x.class}>{x.msg}{x.close !== undefined && x.close && <button className='close' title="Close Notification" onClick={(e)=>{
                                    delete(this.notifications[i]);
                                    
                                    this.setState({
                                      notifications: this.notifications
                                    })
                                  }}><i className="fa-solid fa-circle-xmark"></i></button>}</li>
                                )
                              })
                            }
                          </ul>
                      </div>
                    <div className='row'>
                 
                  <div className='col-lg-12 col-md-12 col-sm-12 content' onClick={this.hideMenu} >
                  
                    <div id="contextMenu" className="context-menu" style={{display: 'none'}}> 
                        <ul className="menu">
                          {this.state.contextMenu.map((x)=>{return x;})}
                        </ul> 
                    </div>
                    {
                      !this.state.filesLoaded ? <div style={{width:"100%", height:"90vh", display:"flex", justifyContent:"center", alignItems:"center"}}><div className='text-center'>
                        <img src='/loader.gif' /><br />Loading...
                        </div></div> : <></>
                    }
                      {
                        this.state.files !== undefined && this.state.files !== null &&

                        <>
                        {
                        this.state.files.length < 1 ?
                        <div className='text-center'>No Data Available</div> :
                            <div className='masonry-container'>

                              <Masonry
                                breakpointCols={breakpointColumnsObj}
                                className="my-masonry-grid"
                                columnClassName="my-masonry-grid_column"
                              >
                              {
                                this.state.files.map((x, i)=>{
                                  return <div
                                    key={i}
                                    className="cardtext-center my-masonry-grid_column"
                                    style={{ borderRadius: "15px" }}
                                  > 
                                      <div className={x.mimeType === 'application/vnd.google-apps.folder' ? 'mb-2 align-self-center' : 'mb-2 align-self-center'} >
                              <div key={x.id} title={x.name} className='card h-100' onContextMenu={this.rightClick} data-json={JSON.stringify(x)} data-id={x.id}>
                                
                                <div className={x.mimeType !== 'application/vnd.google-apps.folder' ? 'card-body p-0' : 'card-body'} data-json={JSON.stringify(x)} data-id={x.id}>
                                  {
                                    x.mimeType === 'application/vnd.google-apps.folder' ?
                                    <div data-id={x.id} onClick={(e)=>{
                                      this.changeLocation(x.id, x);
                                      }} className='text-center' style={x.mimeType !== 'application/vnd.google-apps.folder' ? {flex:"1"} : {}}>
                                      {_app.FileType(x, this.changeLocation)}
                                      
                                    </div> : 
                                    <div className='text-center'>
                                    {_app.FileType(x, this.changeLocation)}

                                    </div>
                                  }
                                  <div className={x.mimeType === 'application/vnd.google-apps.folder' ? 'position-relative' : 'd-none'} style={{wordBreak:"break-word"}}>
                                    <h6 className='fileLink text-start m-0 pt-3' style={{gap:"10px", display:"flex"}} data-id={x.id} onClick={(e)=>{
                                      this.changeLocation(x.id, x);
                                    }}><img className='icon' src={x.iconLink} alt={x.name} style={{position: 'relative', top: '-1px'}} /><span>{x.name}</span></h6>
                                  </div>
                                </div>
                                {
                                      x.mimeType !== 'application/vnd.google-apps.folder' ?
                                <>
                                <div className="card-header text-center">
                               
                                      <div className='row'>
                                        <div className='col-4 align-self-center'>
                                          <small>{fileSize(x.size)}</small>
                                        </div>
                                        <div className='col-8 text-end align-self-center' style={{paddingRight:"15px"}}>
                                        <a href={x.webContentLink} className='btn btn-sm btn-danger mt-1'><i className="fa-solid fa-download"></i> Download</a>
                                        </div>
                                        
                                        
                                      </div>
                                      
                                  </div>
                                <div className='card-footer'>
                                <div><strong>{(i+1)}.)</strong> {x.name}</div>
                                <div className="d-none">
                                {
                                    x.createdTime !== x.modifiedTime ?
                                    <small>Updated on: <span title='Modified' style={{wordBreak:"break-all", whiteSpace:"pre-wrap"}} className='badge bg-secondary'>{new Date(x.modifiedTime).toString()}</span></small> :
                                    <small>Uploaded on: <span title='Uploaded' style={{wordBreak:"break-all", whiteSpace:"pre-wrap"}} className='badge bg-secondary'>{new Date(x.createdTime).toString()}</span></small>
                                  }
                                </div>
                                </div>
                                </> :
                                <>
                                <div className='card-footer'>
                                  <div className=' d-flex' style={{flexDirection:"column"}}>
                                    <div className="dropdown text-start">
                                      <button className="btn btn-danger dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="fa-solid fa-download"></i> Download All
                                      </button>
                                      <ul className="dropdown-menu">
                                        {
                                          x.description !== undefined && x.description.trim() !== "" &&
                                          <li><button onClick={async()=>{
                                            await this.getSDPhotos(x.description, x.name);
                                          }} type='button' className='dropdown-item btn btn-sm btn-info mt-1'><i className="fa-solid fa-download"></i> Standard</button></li>
                                        }
                                        <li><button onClick={async()=>{
                                          await this.getHDPhotos(driveId, x.id, x.name);
                                        }} type='button' className='dropdown-item btn btn-sm btn-danger mt-1'><i className="fa-solid fa-download"></i> High Resolution</button></li>
                                      </ul>
                                    </div>
                                  </div>
                                  
                                </div>
                                </>
                                }
                              </div>
                            </div>
                                  </div>
                                })
                              }
                            </Masonry>

                            </div>
                        }
                        </>
                        
                        
                      }
                  </div>
                </div>
                  </>
                  
                }
                
              </div>
        </main>
      </div>
    );
  }
}

export default App;
